import { fetch } from '@financial-tool/fetch';
import { Expense, ExpenseCreationBody } from '../types/expense';

export default function createExpenseAPI(expense: ExpenseCreationBody) {
  return fetch.post<Expense>('/expenses', expense);
}
